import { useTranslation } from 'react-i18next';
import { MagiclinkButton } from './MagiclinkButton';

interface MagicLinkFormProps {
  email: string;
  onEmailChange: (email: string) => void;
  emailSent: boolean;
  setEmailSent: (sent: boolean) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const MagicLinkForm = ({
  email,
  onEmailChange,
  emailSent,
  setEmailSent,
  inputRef,
}: MagicLinkFormProps) => {
  const [t] = useTranslation('locale');

  return (
    <div className="flex flex-col items-center gap-4 px-4 py-2">
      {!emailSent ? (
        <>
          <p className="text-wrap prose-sm w-full px-2 text-center leading-relaxed">
            {t('Index.welcomeMessage')}
          </p>
          <input
            type="email"
            ref={inputRef}
            className="input-bordered input mb-4 max-w-xs "
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder={t('Index.placeholderEmail')}
            autoComplete="email"
          />
          <MagiclinkButton email={email} setEmailSent={setEmailSent} />
        </>
      ) : (
        <>
          <label className="text-wrap prose-sm label px-2 text-center leading-relaxed">
            {t('Index.confirmationMessage', { email: email })}
          </label>
          <button
            className="btn btn-primary w-52 rounded-md"
            onClick={() => setEmailSent(false)}
          >
            {t('Index.resendMagicLink')}
          </button>
        </>
      )}
    </div>
  );
};
